export interface ProductWithVariants {
  price_cents: number;
  has_variants?: boolean;
  variants?: Array<{
    price_cents: number;
    quantity?: number;
  }>;
}

/**
 * Get the display price for a product (lowest variant price if has variants, otherwise product price)
 */
export function getDisplayPriceCents(product: ProductWithVariants): number {
  if (!product.has_variants || !product.variants || product.variants.length === 0) {
    return product.price_cents ?? 0;
  }
  
  const variantPrices = product.variants
    .map(v => v.price_cents || 0)
    .filter(price => price > 0);
  
  return variantPrices.length > 0 ? Math.min(...variantPrices) : (product.price_cents ?? 0);
}

/**
 * Get total stock from all variants
 */
export function getTotalVariantStock(product: ProductWithVariants & { quantity?: number }): number {
  if (!product.has_variants || !product.variants || product.variants.length === 0) {
    return product.quantity ?? 0;
  }
  
  return product.variants.reduce((total, variant) => total + (variant.quantity || 0), 0);
}
